import { useState } from 'react';
import { Quarter } from '../../types/data';
import { arrowVertical } from 'src/pages/DashboardPage/vpo/ui-icons/icons';
import { TooltipItem } from "src/utils/Tooltip";

const quarters: Quarter[] = ['Q1', 'Q2', 'Q3', 'Q4'];

const QUARTERS: Record<Quarter, string[]> = {
  Q1: ['I кв.', 'январь, февраль, март'],
  Q2: ['II кв.', 'апрель, май, июнь'],
  Q3: ['III кв.', 'июль, август, сентябрь'],
  Q4: ['IV кв.', 'октябрь, ноябрь, декабрь'],
};

const minYear = 2025;

type DatePickerProps = {
  year: number;
  setYear: React.Dispatch<React.SetStateAction<number>>;
  quarterIndex: number;
  setQuarterIndex: React.Dispatch<React.SetStateAction<number>>;
  isSummary: boolean;
  currentDate: unknown;
};

function DatePicker(props: DatePickerProps) {
  const { year, setYear, quarterIndex, setQuarterIndex, isSummary, currentDate } = props;

  const [isOpenCalendar, setIsOpenCalendar] = useState<boolean>(false);

  const quarter = quarters[quarterIndex];

  const currentQuarterIndex = quarters.findIndex((quarter) => quarter === currentDate?.quarter);

  const currentYear = currentDate?.year;

  const handleButtonPrevQuarter = () => {
    if (quarterIndex === 0) {
      setQuarterIndex(3);
      setYear((prev) => prev - 1);
    } else {
      setQuarterIndex((prev) => prev - 1);
    }
  };

  const handleButtonNextQuarter = () => {
    if (quarterIndex === 3) {
      setQuarterIndex(0);
      setYear((prev) => prev + 1);
    } else {
      setQuarterIndex((prev) => prev + 1);
    }
  };

  const handleButtonPrevYear = () => {
    setYear((prev) => prev - 1);
  };

  const handleButtonNextYear = () => {
    setYear((prev) => prev + 1);
  };

  const handleRadioQuarterChange = (index: number) => {
    setQuarterIndex(index);
  };

  const isDisabledPrevQuarter = () => {
    return year < minYear || (year === minYear && quarterIndex < 3);
  };

  const isDisabledNextQuarter = () => {
    return (
      year > currentYear ||
      (year === currentYear && quarterIndex >= currentQuarterIndex)
    );
  };

  const isDisabledPrevYear = () => {
    return year <= 2025;
  };

  const isDisabledNextYear = () => {
    return year >= currentYear;
  };

  console.log('currentYear', currentDate)

  return (
    <>
      <button
        className="mr-3 p-1 disabled:opacity-50"
        type="button"
        onClick={!isSummary ? handleButtonPrevQuarter : handleButtonPrevYear}
        disabled={!isSummary ? isDisabledPrevQuarter() : isDisabledPrevYear()}
      >
        <div className="leading-none">
          <TooltipItem
            position="top"
            tooltipsText={isSummary ? 'Предыдущий год' : 'Предыдущий квартал'}
          >
            {arrowVertical}
          </TooltipItem>
        </div>
      </button>

      <button
        className="p-1 disabled:opacity-50"
        type="button"
        onClick={!isSummary ? handleButtonNextQuarter : handleButtonNextYear}
        disabled={!isSummary ? isDisabledNextQuarter() : isDisabledNextYear()}
      >
        <div className="rotate-180 translate-y-[-2px] origin-center leading-none">
          <TooltipItem
            className="rotate-180 translate-y-[275%]"
            position="top"
            tooltipsText={isSummary ? 'Следующий год' : 'Следующий квартал'}
          >
            {arrowVertical}
          </TooltipItem>
        </div>
      </button>

      <div className="relative w-[120px]">
        <span
          className={`${!isSummary ? 'cursor-pointer' : 'cursor-auto'}`}
          onClick={() => setIsOpenCalendar(!isOpenCalendar)}
        >
          {!isSummary && QUARTERS[quarter][0]} {year}
        </span>

        {isOpenCalendar && !isSummary && (
          <div className="absolute right-0 top-[calc(100%+8px)] z-40 w-[320px] rounded-md bg-[#fff] p-2 shadow">
            <div className="mb-2 flex justify-center gap-2">
              <button
                className="p-1 disabled:opacity-50"
                type="button"
                onClick={handleButtonPrevYear}
                disabled={isDisabledPrevYear()}
              >
                <div>
                  {arrowVertical}
                </div>
              </button>

              <span>{year}</span>

              <button
                className="p-1 disabled:opacity-50"
                type="button"
                onClick={handleButtonNextYear}
                disabled={isDisabledNextYear()}
              >
                <div className="rotate-180">
                  {arrowVertical}
                </div>
              </button>
            </div>

            <div className="flex-col">
              {Object.entries(QUARTERS).map(([key, [label, months]], index) => (
                <label className="radio-button" key={key}>
                  <input
                    className="visually-hidden"
                    type="radio"
                    name="quarters"
                    disabled={(index > currentQuarterIndex && year === currentYear) || (year === minYear && index < 2)}
                    value={key}
                    checked={quarter === key}
                    onChange={() => {
                      handleRadioQuarterChange(index);
                      setIsOpenCalendar(!isOpenCalendar);
                    }}
                  />
                  <div className="cursor-pointer rounded-md px-3 py-2 text-center text-[#637381] hover:text-[#012169]">
                    {label} {months}
                  </div>
                </label>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default DatePicker;
